module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1_m_en.aa2096c57405659d9866db9440632ade.png";